// extracted by mini-css-extract-plugin
module.exports =  {"alert":"fGNC6iI5MBH7721wQylU"};